import {css, StyleSheet} from "aphrodite";
import React from 'react';
import Config from "../config/Config";
import GridStyles from "../styles/styles";
import Image from "./containers/Image";
import TextDiv from "./containers/TextDiv";
import {useSelector} from "react-redux";
import FeatureTickList from "./FeatureTickList";

const FeatureRegular = ({extraStyle, feature, index}) => {
    const commonStyle = {
            image: {
                maxWidth: 540,
                height: "auto",
                width: "100%"
            },
            content: {
                ...GridStyles.define("max-content 16px max-content 24px max-content", "auto"),
                color: Config.colors.FEATURE_NAME,
                alignContent: "center"
            }
        },
        evenStyle = StyleSheet.create({
            container: {
                ...GridStyles.define("max-content", "minmax(280px, 540px) 51px minmax(280px, 464px)")
            },
            image: {
                ...GridStyles.setCol(1),
                ...commonStyle.image
            },
            content: {
                ...GridStyles.setRowCol(1, 3),
                ...commonStyle.content
            }
        }),
        oddStyle = StyleSheet.create({
            container: {
                ...GridStyles.define("max-content", "minmax(auto, 464px) 51px minmax(280px, 540px)")
            },
            image: {
                ...GridStyles.setCol(3),
                ...commonStyle.image
            },
            content: {
                ...GridStyles.setRowCol(1, 1),
                ...commonStyle.content
            }
        }),
        textStyles = StyleSheet.create({
            title: {
                ...GridStyles.setRowCol(1, 1),
                fontSize: 42,
                lineHeight: 1.19,
                fontWeight: "bold"
            },
            description: {
                ...GridStyles.setRowCol(3, 1),
                fontSize: 19,
                lineHeight: 1.53
            },
            tickList: GridStyles.setRowCol(5, 1)
        }),
        styles = index % 2 === 0 ? evenStyle : oddStyle;

    return (
        <div className={css(styles.container, extraStyle)}>
            <Image extraStyle={styles.image} src={feature.image}/>
            <div className={css(styles.content)}>
                <TextDiv extraStyle={textStyles.title} text={feature.title}/>
                <TextDiv extraStyle={textStyles.description} text={feature.description}/>
                {feature.tickList && <FeatureTickList extraStyle={textStyles.tickList} list={feature.tickList}/>}
            </div>
        </div>
    );
};

const FeatureMobile = ({extraStyle, feature}) => {
    const styles = StyleSheet.create({
        container: {
            ...GridStyles.define(`max-content 20px max-content 17px max-content 16px max-content`, "auto"),
            color: Config.colors.FEATURE_NAME,
            justifyContent: "center",
            textAlign: "center"
        },
        title: {
            ...GridStyles.setRowCol(1, 1),
            fontSize: 36,
            lineHeight: 1.22,
            fontWeight: "bold"
        },
        image: {
            ...GridStyles.setRowCol(3, 1),
            height: "auto",
            margin: "0 auto",
            width: "100%"
        },
        description: {
            ...GridStyles.setRowCol(5, 1),
            fontSize: 18,
            lineHeight: 1.44
        },
        tickList: GridStyles.setRowCol(7, 1)
    });

    return (
        <div className={css(styles.container, extraStyle)}>
            <TextDiv extraStyle={styles.title} text={feature.title}/>
            <Image extraStyle={styles.image} src={feature.image}/>
            <TextDiv extraStyle={styles.description} text={feature.description}/>
            {feature.tickList && <FeatureTickList extraStyle={styles.tickList} list={feature.tickList}/>}
        </div>
    );
};

const Feature = (parameters) => {
    const {isMobile} = useSelector(state => state.styles);

    return isMobile ? <FeatureMobile {...parameters}/> : <FeatureRegular {...parameters}/>;
};

export default Feature;
